import React, {useCallback} from 'react';
import styles from './HeaderLogo.module.scss'
import {useSelector} from "react-redux";
import {buttonClick} from "utils/Helpers";

const HeaderLogo = (props) => {

    const accessible = useSelector(state => state.accessible);
    const panelData = useSelector(state => state.panelData);

    const getSrc = useCallback(()=>{
        let newSrc = 'https://msobd-storage.azureedge.net/images/ms-logo-white.png';
        if(panelData.stackOrder.cache === 'active' || panelData.stackOrder.martellus === 'active'){
            newSrc = 'https://msobd-storage.azureedge.net/images/ms-logo.png'
        }
        return newSrc;
    }, [panelData])

    return (
        <div aria-hidden={props.ariaHidden} role={'link'} aria-label={'Microsoft Logo, return home'} onKeyDown={buttonClick} onClick={props.menuClick} className={`${styles.surface} ${(!accessible.exploring && !props.relative) ? styles.locked : ''}`} /*href={'http://www.surface.com'} target={'_blank'} rel="noreferrer"*/>
            <img src={getSrc()} alt={'Microsoft Surface'}/>
        </div>
    )
};

export default HeaderLogo
